import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import LOGO_IMAGE from '../assets/img/SIMBOLO_principal.png';
import BG_IMAGE from  '../assets/img/Login.jpg';
import AlterarSenha from './modal/AlterarSenha';
import RecuperarSenha from './modal/RecuperarSenha';
import OTPModal from './modal/OTP';
import Api from "../api/Api";
import { toast } from "react-toastify";




export default function Login() {
    const { code } = useParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [logoHovered, setLogoHovered] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [modalOTP, setModalOTP] = useState(false);
  const [modalAlterarSenha, setModalAlterarSenha] = useState(false);
  const [modalRecuperarSenha, setModalRecuperarSenha] = useState(false);
    const [loading, setLoading] = useState(false);
  

  useEffect(() => {
    setTimeout(() => setMounted(true), 100);
    if(code){
      toast.warning("Para continuar deve alterar a senha");
        setModalAlterarSenha(true);
    }
  }, []);



const handleKeyDown = (e) => {
  if (e.key === "Enter") handleSubmit(e);
};



const handleSubmit = async (e) => {

  setLoading(true);
  if (e?.preventDefault) e.preventDefault();

  
  if (!email.trim()) {
    toast.error("Introduz o teu email.");
    setLoading(false);
    return;
  }
  if (!password.trim()) {
    toast.error("Introduz a tua palavra-passe.");
     setLoading(false);
    return;
  }

  const payload = { email, password };
  const response = await Api.Login(payload);



   if(response.status===425){
    toast.success("Login realizado. Verifique o seu e-mail para obter o código OTP.");
    setModalOTP(true);
 
   
  }

  else if(response.status===420){
    toast.error("E-mail ou palavra-passe incorretos, por favor tente novamente.");
    
  }

  else if(response.status===421){
    toast.warning("Para continuar deve alterar a senha");
    setModalAlterarSenha(true);
  }

    else if(response.status===421){
    toast.warning("Para continuar deve alterar a senha");
    setModalAlterarSenha(true);
  }

      else if(response.status===423){
    toast.error("Conta bloqueada após 3 tentativas falhadas. Contacte o administrador.");
 
  }

  else if(response.status===422){
    toast.error("Conta eliminada");
 
  }

 else  {
    toast.error("Erro desconhecido, por favor contacte o administrador.");
  }



 setLoading(false);
  


}


    const handleRecoverPassword = (e) => {
 
    setModalRecuperarSenha(true);
   
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        body { font-family: 'Inter', sans-serif; }

        .login-root {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          overflow: hidden;
          background: #020b1a;
          font-family: 'Inter', sans-serif;
        }

        .bg-image {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          opacity: 0.85;
          pointer-events: none;
          user-select: none;
        }

        /* Subtle left-side dark overlay so card pops */
        .bg-overlay {
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse at 30% 50%, rgba(2,11,26,0.55) 0%, transparent 70%),
                      linear-gradient(to right, rgba(2,11,26,0.4) 0%, transparent 60%);
          pointer-events: none;
        }

        /* ── CARD ── */
        .card {
          position: relative;
          z-index: 10;
          display: flex;
          border-radius: 20px;
          overflow: hidden;
          width: min(900px, 95vw);
          min-height: 520px;
          box-shadow: 0 32px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.06);
          transform: translateY(${mounted ? "0" : "28px"});
          opacity: ${mounted ? 1 : 0};
          transition: transform 0.7s cubic-bezier(.22,1,.36,1), opacity 0.7s ease;
        }

        /* ── LEFT PANEL ── */
        .left-panel {
          flex: 1.1;
          background: rgba(3, 14, 35, 0.72);
          backdrop-filter: blur(18px);
          -webkit-backdrop-filter: blur(18px);
          border-right: 1px solid rgba(0, 174, 255, 0.12);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 56px 40px;
          gap: 24px;
          position: relative;
          overflow: hidden;
        }

        /* Ambient glow behind logo */
        .left-panel::before {
          content: '';
          position: absolute;
          width: 280px;
          height: 280px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(0,174,255,0.18) 0%, transparent 70%);
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          pointer-events: none;
        }

        /* Floating particles */
        .particle {
          position: absolute;
          border-radius: 50%;
          animation: floatParticle linear infinite;
          opacity: 0.5;
        }
        @keyframes floatParticle {
          0%   { transform: translateY(0px) rotate(0deg); opacity: 0.4; }
          50%  { opacity: 0.8; }
          100% { transform: translateY(-320px) rotate(360deg); opacity: 0; }
        }

        /* ── LOGO ── */
        .logo-wrapper {
          position: relative;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 160px;
          height: 160px;
          z-index: 2;
        }

        .logo-img {
          width: 130px;
          height: 130px;
          object-fit: contain;
          transition: transform 0.4s cubic-bezier(.22,1,.36,1),
                      filter 0.4s ease;
          filter: drop-shadow(0 0 16px rgba(0,174,255,0.5))
                  drop-shadow(0 0 40px rgba(0,90,255,0.35));
        }

        .logo-wrapper:hover .logo-img {
          transform: scale(1.1) rotate(-3deg);
          filter: drop-shadow(0 0 28px rgba(0,174,255,0.9))
                  drop-shadow(0 0 60px rgba(0,90,255,0.6))
                  drop-shadow(0 0 8px rgba(255,255,255,0.3));
        }

        /* Ping ring on hover */
        .logo-ring {
          position: absolute;
          inset: 0;
          border-radius: 50%;
          border: 2px solid rgba(0,174,255,0.6);
          opacity: 0;
          transform: scale(0.7);
          transition: opacity 0.3s, transform 0.4s cubic-bezier(.22,1,.36,1);
        }
        .logo-wrapper:hover .logo-ring {
          opacity: 1;
          transform: scale(1);
          animation: ringPulse 1.4s ease-out infinite;
        }
        @keyframes ringPulse {
          0%   { transform: scale(1);   opacity: 0.7; }
          100% { transform: scale(1.6); opacity: 0; }
        }

        .brand-name {
          font-size: 1.5rem;
          font-weight: 700;
          letter-spacing: 0.08em;
          background: linear-gradient(135deg, #00c6ff 0%, #0057ff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          z-index: 2;
          text-transform: uppercase;
        }

        .brand-tagline {
          font-size: 0.75rem;
          font-weight: 400;
          color: rgba(160, 210, 255, 0.65);
          letter-spacing: 0.12em;
          text-align: center;
          z-index: 2;
          text-transform: uppercase;
        }

        /* ── RIGHT PANEL (FORM) ── */
        .right-panel {
          flex: 1;
          background: rgba(255,255,255,0.97);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 56px 48px;
          gap: 0;
        }

        .form-heading {
          font-size: 1.75rem;
          font-weight: 700;
          color: #0d1b2a;
          margin-bottom: 6px;
          letter-spacing: -0.02em;
        }

        .form-subheading {
          font-size: 0.85rem;
          color: #7a8fa6;
          margin-bottom: 36px;
          font-weight: 400;
        }

        .input-group {
          display: flex;
          flex-direction: column;
          gap: 14px;
          margin-bottom: 28px;
        }

        .input-wrapper {
          position: relative;
          display: flex;
          align-items: center;
        }

        .input-icon {
          position: absolute;
          left: 16px;
          color: #9ab0c8;
          pointer-events: none;
          display: flex;
          align-items: center;
          transition: color 0.2s;
        }

        .input-field {
          width: 100%;
          height: 50px;
          padding: 0 16px 0 46px;
          border-radius: 12px;
          border: 1.5px solid #e2eaf0;
          background: #f5f9fd;
          font-size: 0.9rem;
          color: #1a2b3c;
          font-family: 'Inter', sans-serif;
          outline: none;
          transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
        }

        .input-field::placeholder { color: #a8bfcf; }

        .input-field:focus {
          border-color: #0090e7;
          background: #fff;
          box-shadow: 0 0 0 3px rgba(0,144,231,0.12);
        }

        .input-field:focus + .input-icon,
        .input-wrapper:focus-within .input-icon { color: #0090e7; }

        .toggle-pass {
          position: absolute;
          right: 14px;
          background: none;
          border: none;
          cursor: pointer;
          color: #9ab0c8;
          display: flex;
          align-items: center;
          padding: 4px;
          transition: color 0.2s;
        }
        .toggle-pass:hover { color: #0090e7; }

        .btn-login {
          width: 100%;
          height: 52px;
          border-radius: 12px;
          border: none;
          cursor: pointer;
          font-size: 0.95rem;
          font-weight: 600;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          color: #fff;
          background: linear-gradient(135deg, #00aaff 0%, #0044ee 100%);
          box-shadow: 0 6px 24px rgba(0,100,255,0.35);
          transition: transform 0.18s, box-shadow 0.18s, filter 0.18s;
          margin-bottom: 20px;
          font-family: 'Inter', sans-serif;
        }

        .btn-login:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 32px rgba(0,100,255,0.5);
          filter: brightness(1.08);
        }

        .btn-login:active {
          transform: translateY(0);
          box-shadow: 0 4px 14px rgba(0,100,255,0.3);
        }

        .forgot-link {
          text-align: center;
          font-size: 0.8rem;
          color: #8aa0b6;
          margin-bottom: 32px;
        }

        .forgot-link a {
          color: #0077cc;
          text-decoration: none;
          font-weight: 500;
          transition: color 0.2s;
        }
        .forgot-link a:hover { color: #0055aa; text-decoration: underline; }

        .divider {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
        }

        .divider-line {
          flex: 1;
          height: 1px;
          background: #e2eaf0;
        }

        .divider-text {
          font-size: 0.75rem;
          color: #b0c2d0;
          white-space: nowrap;
        }

        .create-account {
          text-align: center;
          font-size: 0.82rem;
          color: #8aa0b6;
        }

        .create-account a {
          color: #0077cc;
          font-weight: 600;
          text-decoration: none;
          transition: color 0.2s;
        }
        .create-account a:hover { color: #0044cc; }

        .background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 0;
        filter: blur(3px);

}

.btn-login:disabled {
  opacity: 0.75;
  cursor: not-allowed;
  transform: none;
  filter: none;
}

.btn-login-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.spinner {
  width: 18px;
  height: 18px;
  border: 2.5px solid rgba(255,255,255,0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  flex-shrink: 0;
}
  @keyframes spin {
  to { transform: rotate(360deg); }
}


        @media (max-width: 640px) {
          .left-panel { display: none; }
          .right-panel { padding: 40px 28px; border-radius: 20px; }
          .card { min-height: auto; }
        }
      `}</style>

      <div className="login-root">
        {/* Background image 
        <img src={BG_IMAGE} alt="" className="bg-image" />
*/}
      <div 
        className="background-image"
        style={{ backgroundImage: `url(${BG_IMAGE})` }}
      ></div>


        <div className="bg-overlay" />

        {/* Floating particles */}
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              width: `${4 + (i % 3) * 3}px`,
              height: `${4 + (i % 3) * 3}px`,
              background: i % 2 === 0 ? "rgba(0,174,255,0.6)" : "rgba(0,90,255,0.5)",
              left: `${10 + i * 13}%`,
              bottom: `${5 + (i % 3) * 8}%`,
              animationDuration: `${5 + i * 1.5}s`,
              animationDelay: `${i * 0.9}s`,
            }}
          />
        ))}

        <div className="card">
          {/* ── LEFT PANEL ── */}
          <div className="left-panel">
            <div
              className="logo-wrapper"
              onMouseEnter={() => setLogoHovered(true)}
              onMouseLeave={() => setLogoHovered(false)}
            >
              <div className="logo-ring" />
              <img src={LOGO_IMAGE} alt="Logo" className="logo-img" />
            </div>

         
          </div>

          {/* ── RIGHT PANEL ── */}
          <div className="right-panel">
            <div className="form-heading">Bem-vindo</div>
            <div className="form-subheading">Inicia sessão na tua conta</div>

            <div className="input-group">
              {/* Email */}
              <div className="input-wrapper">
                <span className="input-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="4" width="20" height="16" rx="2"/>
                    <path d="m22 7-10 7L2 7"/>
                  </svg>
                </span>
<input
  type="email"
  className="input-field"
  placeholder="Email"
  value={email}
  onChange={(e) => setEmail(e.target.value)}
  onKeyDown={handleKeyDown}   // ← adiciona aqui
/>
              </div>

              {/* Password */}
              <div className="input-wrapper">
                <span className="input-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                </span>
         <input
  type={showPass ? "text" : "password"}
  className="input-field"
  placeholder="Palavra-passe"
  value={password}
  onChange={e => setPassword(e.target.value)}
  onKeyDown={handleKeyDown}   // ← e aqui
/>
                <button
                  className="toggle-pass"
                  onClick={() => setShowPass(p => !p)}
                  type="button"
                  aria-label="Mostrar/ocultar senha"
                >
                  {showPass ? (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                      <line x1="1" y1="1" x2="23" y2="23"/>
                    </svg>
                  ) : (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  )}
                </button>
              </div>
            </div>

<button
  className="btn-login"
  onClick={handleSubmit}
  type="button"
  disabled={loading}
>
  <div className="btn-login-inner">
    {loading && <span className="spinner" />}
    {loading ? "A entrar..." : "Entrar"}
  </div>
</button>

            <div className="forgot-link">
              Esqueceste a <a href="#" onClick={handleRecoverPassword}>palavra-passe</a>?
            </div>

  <div className="divider">
              <div className="divider-line" />
              <span className="divider-text"></span>
              <div className="divider-line" />
            </div>

            <div className="create-account">
               <p className="signup-text">
    © {new Date().getFullYear()} <strong>Tech Next </strong>- Todos os direitos reservados.
  </p>
  <p className="signup-text">
    Versão 1.0.0
  </p>
            </div>

        
          </div>

        </div>

                        <OTPModal
        isOpen={modalOTP}
        onClose={() => setModalOTP(false)}
        destination={email}
      />


      <RecuperarSenha
        isOpen={modalRecuperarSenha}
        onClose={() => setModalRecuperarSenha(false)}
      />


      <AlterarSenha
        isOpen={modalAlterarSenha}
        onClose={() => setModalAlterarSenha(false)}
        code={code}
        email={email}
       
      />




















      </div>


    </>
  );
}